import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import NewsListPage from "../pages/news/page";
import NewsDetailPage from "../pages/news/detail/page";
import AnimeListPage from "../pages/anime/page";
import AnimeDetailPage from "../pages/anime/detail/page";
import SearchPage from "../pages/search/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsListPage /> },
      { path: "news/:id", element: <NewsDetailPage /> },
      { path: "anime", element: <AnimeListPage /> },
      { path: "anime/:id", element: <AnimeDetailPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "contact", element: <ContactPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;